import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import {
  Button,
  DropdownWithSearch,
  TextInput,
  Image,
} from "hesus-ui-kit";
import { getDateFormat } from "@utils/datePickerUtils";
import { useDebounce } from "use-debounce";
import BarLoader from "react-spinners/BarLoader";
import { useGetGeneralParameters } from "@hooks/useGeneralParams";
import EnquiryAction from "./components/EnquiryAction";
import EnquiryPriority from "./components/EnquiryPriority";
import EnquiryService from "./components/EnquiryService";
import EnquiryStatus from "./components/EnquiryStatus";
import EnquirySolutions from "./components/EnquirySolutions";
import EnquirySellingPrice from "../../SellingPrice/SellingPricesList/components/EnquirySellingPrice";
import PaginationData from "@shared/baseUI/PaginationData/PaginationData";
import transportOnlyIcon from "@icons/ic-transport-only.svg";
import { loadAllEnquiries } from "./EnquiryList.actionCreators";
import { setAllEnquiriesLoadingState } from "./EnquiryList.slice";
import { searchInputStyles } from "@utils/extra-style";
import UserInfo from "@utils/UserInfo";
import { ENQUIRIES_LIST_ENDPOINT, enquiryTypeOptions } from "@utils/constants";

import { addressSingleLine } from "@utils/utils";

import {
  OuterWrapper,
  FlexRow,
  FilterFlexRow,
  SectionContainer,
  GridRow,
  ProductContainer,
  FilterOuter,
  GlobalSearch,
  InfoContainer,
  NoEnquiry,
  DestinationContainer,
  ButtonWrapper,
  CreateButton,
  SubTitle,
  SiteCreationPageContainer,
} from "./EnquiryList.styled";

import "./EnquiryList.scss";

const ViewData = (props) => {
  const {
    t,
    isRefreshList,
    updateRefeshStatus,
    entityId,
    entityType,
    createEnquiry,
    page,
  } = props;

  const history = useNavigate();
  const countryId = UserInfo.countryId();
  const dispatch = useDispatch();
  const generalParams = useGetGeneralParameters();
  const { countryList } = generalParams;
  const [enquiryData, setEnquiryData] = useState([]);
  const [isRefreshDataAgain, setRefreshState] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageStart, setPageStart] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [search, setSearch] = useState("");
  const [sort, setSortOption] = useState({ dir: "asc", column: "step" });
  const [requestData, setRequestData] = useState({});
  const [statusType, setStatusType] = useState([]);
  const [statusTypeFilter, setStatusTypeFilter] = useState([]);
  const [selectedSolutionIds, setSelectedSolutionIds] = useState([]);
  const dataURL = ENQUIRIES_LIST_ENDPOINT;

  const enquiryListByIds = useSelector((state) => state.enquiryList.byId);
  const enquiryListAllIds = useSelector((state) => state.enquiryList.allIds);
  const filteredRecords = useSelector(
    (state) => state.enquiryList.filteredRecords
  );
  const isEnquiryListLoading = useSelector(
    (state) => state.enquiryList.isLoading
  );

  const [query, setQuery] = useState(search);
  const [debounceQuery] = useDebounce(query, 700);

  useEffect(() => {
    setLoading(isEnquiryListLoading);
  }, [isEnquiryListLoading]);

  const tranportEnquiry = () => {
    return `<span style="color:#084987">` + t("DESTINATION") + `</span>`;
  };

  const onFinish = () => {
    history(`/site/view/${entityId}/general-info`);
  };

  useEffect(() => {
    if (isRefreshDataAgain) {
      setRefreshState(false);
    }
    if (isRefreshList) {
      setRefreshState(true);
    }
  }, [isRefreshDataAgain, isRefreshList]);

  const handleChange = (e) => {
    setQuery(e.target.value || undefined);
  };

  useEffect(() => {
    setSearch(query);
    setCurrentPage(1);
  }, [debounceQuery]);
  // const globalSearchFilter = (e) => {
  //   setSearch(e.target.value);
  //   setCurrentPage(1);
  // };

  const onEnquiryTypeFilterChange = (statusValue) => {
    setStatusType(statusValue);
    let typeFilter = [];
    statusValue.map((item) => {
      item.value !== "*" && typeFilter.push(item.value);
    });
    setStatusTypeFilter(typeFilter);
  };
  /**
   * Method to fetch set of records based on the filters applied.
   * @param {pageSize} pageSize
   * @param {pageStart} pageStart
   * @param {globalFilter} globalFilter
   * @param {sort} sort
   * @param {appliedFilters} appliedFilters
   */
  const fetchRecords = ({
    pageSize,
    pageStart,
    search,
    sort,
    appliedFilters,
    currentPage,
  }) => {
    // save request data,
    setRequestData({ pageSize, pageStart, search, sort, appliedFilters });
    // Set the loading state
    setLoading(true);

    dispatch(setAllEnquiriesLoadingState());
    dispatch(
      loadAllEnquiries({
        dataURL,
        pageSize,
        currentPage,
        sort,
        search,
        appliedFilters,
        status: 1,
      })
    );
  };

  useEffect(() => {
    if (!loading) {
      fetchRecords({
        pageSize,
        pageStart,
        search,
        sort,
        appliedFilters: {
          status: statusTypeFilter,
          siteId: entityId,
          dependancies:
            page !== "createSite"
              ? JSON.stringify(["solution", "sellingPrices"])
              : "",
        },
        currentPage,
      });
    }
  }, [
    currentPage,
    pageSize,
    pageStart,
    statusTypeFilter,
    search,
    isRefreshDataAgain,
  ]);

  useEffect(() => {
    if (
      enquiryListAllIds.length > 0 &&
      enquiryListByIds[enquiryListAllIds[0]].site.id === entityId
    ) {
      const responseData = enquiryListAllIds.map((id) => {
        const tempData = { ...enquiryListByIds[id] };
        return tempData;
      });
      setEnquiryData([...responseData]);
      setPageCount(filteredRecords);
      setLoading(false);
    } else {
      setEnquiryData([]);
      setPageCount(0);
      setLoading(false);
    }
  }, [t, enquiryListAllIds, enquiryListByIds, filteredRecords]);

  useEffect(() => {
    const solutionIds = [];
    enquiryData.map((data) => {
      data.sellingPrices?.map((sellingPricesList) => {
        solutionIds[sellingPricesList.id] = [];
        sellingPricesList.services.map((service) => {
          solutionIds[sellingPricesList.id][
            parseInt(service.hesusService.id, 10)
          ] = [];
          service.solutions.map((solutionInfo) => {
            solutionIds[sellingPricesList.id][
              parseInt(service.hesusService.id, 10)
            ].push(solutionInfo.solution.id);
          });
        });
      });
    });
    setSelectedSolutionIds(solutionIds);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enquiryData]);

  return (
    <>
      <OuterWrapper>
        <FlexRow>
          <SectionContainer>
            <div>
              <FilterFlexRow>
                {page !== "createSite" && (
                  <>
                    <FilterOuter>
                      <DropdownWithSearch
                        label={t("ENQUIRIES_FILTER_STEP")}
                        placeholder={t("SEARCH")}
                        name="enquiry-type-filter"
                        labelClass="enquiry-list__quote-status-label"
                        containerClass="enquiry-list__quote-status-dropdown-container"
                        value={statusType || ""}
                        defaultOption="Nothing Selected"
                        options={enquiryTypeOptions(t)}
                        onChange={onEnquiryTypeFilterChange}
                        containerStyles={{ minWidth: "12rem;" }}
                      />
                    </FilterOuter>
                    <GlobalSearch>
                      <div className="search-box">
                        <TextInput
                          id="enquiry-list-search"
                          type="search"
                          inputClass="search-box-default-input"
                          value={query || ""}
                          onChange={(e) => handleChange(e)}
                          placeholder=""
                          name="global-filter"
                          inputStyles={searchInputStyles}
                        />
                      </div>
                    </GlobalSearch>
                  </>
                )}

                <ButtonWrapper>
                  <CreateButton onClick={createEnquiry}>{`${t(
                    "ACTION_NEW_ENQUIRY"
                  )}`}</CreateButton>
                </ButtonWrapper>
              </FilterFlexRow>
            </div>
            <div>
              {loading && <BarLoader width="100%" color="#1bace4" />}
              <GridRow>
                {enquiryData?.length !== "" &&
                  enquiryData?.map((data, index) => {
                    return (
                      <ProductContainer key={index}>
                        <GridRow
                          column={`${
                            data.step === 1 &&
                            (parseInt(data.priority, 10) === 3 ||
                              parseInt(data.priority, 10) === 2 ||
                              parseInt(data.priority, 10) === 1 ||
                              !data.priority)
                              ? "auto 1fr auto auto"
                              : "1fr auto auto"
                          }`}
                          gap="0rem"
                        >
                          {data.step === 1 &&
                            (parseInt(data.priority, 10) === 3 ||
                              parseInt(data.priority, 10) === 2 ||
                              parseInt(data.priority, 10) === 1 ||
                              !data.priority) && (
                              <EnquiryPriority data={data} page="requestList" />
                            )}
                          <GridRow
                            gap="0rem"
                            opacity={data.step !== 6 ? 1 : "0.2"}
                          >
                            <GridRow column="auto 1fr" gap="0rem">
                              <Link
                                to={`/site/view/${data.site?.id}/enquiry-view-${data.id}`}
                                id={`enquiry-id${data.id}`}
                                className="enquiry-listing__enquiry-link"
                              >
                                {data?.id +
                                  " - " +
                                  t(data?.subCategory?.name) +
                                  " - " +
                                  data?.product?.name}
                              </Link>
                            </GridRow>
                            <InfoContainer>
                              <EnquiryService service={data?.service} />
                              {data?.quantity + " " + t(data?.unit) + " - "}
                              {data.dateType === 1 &&
                                getDateFormat(data.startDate,"YYYY-MM-DD")}
                              {data.dateType !== 1 &&
                                t("GENERAL_FROM") +
                                  " " +
                                  getDateFormat(data.startDate,"YYYY-MM-DD") +
                                  " " +
                                  t("GENERAL_TO") +
                                  " " +
                                  getDateFormat(data.endDate,"YYYY-MM-DD")}
                            </InfoContainer>
                            {data?.subCategory?.id === 9 &&
                              page !== "createSite" && (
                                <DestinationContainer
                                  dangerouslySetInnerHTML={{
                                    __html:
                                      tranportEnquiry() +
                                      " : " +
                                      addressSingleLine(
                                        countryId,
                                        data.destination,
                                        countryList
                                      ),
                                  }}
                                ></DestinationContainer>
                              )}
                          </GridRow>
                          <GridRow
                            marginRight="1.5rem"
                            opacity={data.step !== 6 ? 1 : "0.2"}
                          >
                            {page !== "createSite" && (
                              <EnquiryStatus step={data?.step ?? 1} />
                            )}
                          </GridRow>
                          <GridRow>
                            <EnquiryAction
                              enquiryId={data.id}
                              step={data?.step ?? 1}
                              onRefreshData={setRefreshState}
                              enquiryData={data}
                              page={page}
                            />
                          </GridRow>
                        </GridRow>
                        {page !== "createSite" && (
                          <>
                            {[2, 5, 9].includes(data.step) && (
                              <GridRow
                                opacity={data.step !== 6 ? 1 : "0.2"}
                                marginTop="15px;"
                              >
                                <EnquirySolutions
                                  solutionData={data?.solutions}
                                  onRefreshData={setRefreshState}
                                />
                              </GridRow>
                            )}

                            {[2, 5, 9].includes(data.step) && (
                              <GridRow opacity={data.step !== 6 ? 1 : "0.2"}>
                                <EnquirySellingPrice
                                  sellingPriceData={data?.sellingPrices}
                                  onRefreshData={setRefreshState}
                                  enquiryData={data}
                                  updateRefeshStatus={updateRefeshStatus}
                                  page="enquiryList"
                                  loading={false}
                                  requestId={data?.id}
                                  selectedSolutionIds={selectedSolutionIds}
                                />
                              </GridRow>
                            )}
                          </>
                        )}
                        {page === "createSite" && (
                          <SiteCreationPageContainer>
                            {data.trucks !== null && (
                              <GridRow
                                column="1fr"
                                opacity={data.step !== 6 ? 1 : "0.2"}
                              >
                                <FlexRow>
                                  <Image
                                    src={transportOnlyIcon}
                                    alt={t("TRANSPORT_ONLY")}
                                    title={t("TRANSPORT_ONLY")}
                                    className="enquiry-listing__image-icon"
                                  />
                                  <SubTitle
                                    color="#767676"
                                    paddingLeft="10px"
                                    marginBottom="0px"
                                  >
                                    {data.trucks
                                      .map((truck) => truck.name)
                                      .join(", ")}
                                  </SubTitle>
                                </FlexRow>
                              </GridRow>
                            )}
                            <GridRow
                              column="1fr 1fr 1fr"
                              gap="0rem"
                              marginTop="15px"
                              opacity={data.step !== 6 ? 1 : "0.2"}
                            >
                              <FlexRow>
                                <SubTitle fontWeight="700" paddingLeft="0px">
                                  {t("ENQUIRY_LOADS_PER_DAY")} :
                                </SubTitle>
                                <SubTitle color="#767676" paddingLeft="10px">
                                  {data?.loadsPerDay + " " + t("LOADS")}
                                </SubTitle>
                              </FlexRow>
                              <FlexRow>
                                <SubTitle fontWeight="700">
                                  {t("ENQUIRY_COMPLEMENTARY_ANALYSIS")} :
                                </SubTitle>
                                <SubTitle color="#767676" paddingLeft="10px">
                                  {data?.analysis ?? 0}
                                </SubTitle>
                              </FlexRow>
                              {data?.requestedPrice !== null && (
                                <FlexRow>
                                  <SubTitle fontWeight="700">
                                    {t("ENQUIRY_REQUESTED_PRICE")} :
                                  </SubTitle>
                                  <SubTitle color="#767676" paddingLeft="10px">
                                    {data?.requestedPrice}
                                  </SubTitle>
                                </FlexRow>
                              )}
                              {data?.site?.platformCountry?.id === 1 && (
                                <FlexRow>
                                  <SubTitle fontWeight="700">
                                    {t("ENQUIRY_PURCHASE_ORDER")} :
                                  </SubTitle>
                                  <SubTitle color="#767676" paddingLeft="10px">
                                    {data?.purchaseOrder}
                                  </SubTitle>
                                </FlexRow>
                              )}
                            </GridRow>
                            {data?.product?.category?.id === 4 && (
                              <GridRow opacity={data.step !== 6 ? 1 : "0.2"}>
                                <FlexRow>
                                  <SubTitle fontWeight="700" paddingLeft="0px">
                                    {t("DESTINATION")} :
                                  </SubTitle>
                                  <SubTitle color="#767676" paddingLeft="10px">
                                    {addressSingleLine(
                                      countryId,
                                      data?.destination,
                                      countryList
                                    )}
                                  </SubTitle>
                                </FlexRow>
                              </GridRow>
                            )}
                            <GridRow
                              gap="0"
                              opacity={data.step !== 6 ? 1 : "0.2"}
                            >
                              <SubTitle
                                fontWeight="700"
                                paddingLeft="0px"
                                marginBottom="5px"
                              >
                                {t("ENQUIRY_HESUS_INFORMATION")} :
                              </SubTitle>

                              <SubTitle
                                paddingLeft="10px"
                                color="#767676"
                                dangerouslySetInnerHTML={{
                                  __html: data?.internalComment,
                                }}
                              ></SubTitle>
                            </GridRow>
                          </SiteCreationPageContainer>
                        )}
                      </ProductContainer>
                    );
                  })}
              </GridRow>
              {(enquiryData?.length === "" || enquiryData?.length === 0) &&
                !loading && (
                  <GridRow column="1fr">
                    <NoEnquiry>{t("SITE_NO_ENQUIRIES")}</NoEnquiry>
                  </GridRow>
                )}
              {page === "createSite" && (
                <ButtonWrapper>
                  <Button
                    styles={{
                      color: "white",
                      background: "#1BACE4",
                      border: "1px solid #1BACE4",
                      float: "right",
                      marginTop: "20px",
                      marginRight: "0.32rem",
                      "&:hover": {
                        backgroundColor: "#1589b6",
                      },
                    }}
                    onClick={onFinish}
                  >
                    <>{t("FINISH")}</>
                  </Button>
                </ButtonWrapper>
              )}
            </div>
          </SectionContainer>
        </FlexRow>

        {enquiryData?.length !== 0 && page !== "createSite" && (
          <PaginationData
            pageCount={parseInt(pageCount, 10)}
            pageSize={requestData.pageSize}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            pageStart={pageStart}
            setPageStart={setPageStart}
            setPageSize={setPageSize}
          />
        )}
      </OuterWrapper>
    </>
  );
};

ViewData.propTypes = {
  t: PropTypes.func.isRequired,
  isRefreshList: PropTypes.bool.isRequired,
  page: PropTypes.string,
};

ViewData.defaultProps = {
  page: "",
};

export default withTranslation()(ViewData);
